import React from "react";
import { Separator } from "src/components/ui/separator";
import { cn } from "src/lib/utils";

interface MenuSeparatorProps {
  isOpen: boolean;
  className?: string;
}

const MenuSeparator: React.FC<MenuSeparatorProps> = ({ isOpen, className }) => {
  if (!isOpen) {
    return (
      <div className={cn("px-2 py-1 w-full", className)}>
        <Separator />
      </div>
    );
  }

  return (
    <div className={cn("px-2 py-1", className)}>
      <Separator />
    </div>
  );
};

export default MenuSeparator;
